exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a.token{text-decoration:none}.token.keyword,.token.punctuation,.token.selector{color:#db7093}.token.number,.token.property,.token.punctuation,.token.string,.token.tag-id{color:#1e90ff}.token.attr-name,.token.function{color:#5f9ea0}.token.atrule .atrule-id{color:#8a2be2}.token.boolean{color:#789}.token.comment{color:#a9a9a9}.language-php .variable{color:#5f9ea0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?{ browsers: ['last 100 versions'] }!./src/vendor/prism.css
// module id = 83
// module chunks = 0